<div class="block order-success" *ngIf="ordine">
      <app-restaurant-header></app-restaurant-header>
    <div class="container">
        <div class="order-success__body">
            <div class="order-success__header">
                <app-icon class="order-success__icon" name="check-100" size="100"></app-icon>
                <h1 class="order-success__title">{{ 'CART.THANK_YOU' | translate }}</h1>
                <div class="order-success__subtitle">{{ 'CART.ORDER_RECEIVED' | translate }}</div>
                <div class="order-success__actions">
                    <a routerLink="/" class="btn btn-xs btn-primary-darken">{{ 'CART.BACK_HOME' | translate }}</a>
                </div>
            </div>

            <div class="order-success__meta">
                <ul class="order-success__meta-list">
                    <li class="order-success__meta-item">
                        <span class="order-success__meta-title">{{ 'CART.ORDER_NUMBER' | translate }}</span>
                        <span class="order-success__meta-value">#{{ ordine.numreg }}</span>
                    </li>
                    <li class="order-success__meta-item">
                        <span class="order-success__meta-title">{{ 'CART.DOCUMENT_DATE' | translate }}</span>
                        <span class="order-success__meta-value">{{ ordine.dataDocumento }}</span>
                    </li>
                    <li class="order-success__meta-item">
                        <span class="order-success__meta-title">{{ 'CART.TOTAL' | translate }}</span>
                        <span class="order-success__meta-value">{{ ordine.totaleAPagare |
                            currencyFormat }}</span>
                    </li>
                    <li class="order-success__meta-item">
                        <span class="order-success__meta-title">{{ 'CART.PAYMENT_METHOD' | translate }}</span>
                        <span class="order-success__meta-value">{{ condDiPagamento }}</span>
                    </li>
                </ul>
            </div>

            <div class="card">
                <div class="order-list">
                    <table>
                        <thead class="order-list__header">
                            <tr>
                                <th class="order-list__column-label" colspan="2">{{ 'CART.ITEM' | translate }}</th>
                                <th class="order-list__column-quantity">{{ 'CART.QTY' | translate }}</th>
                                <th *ngIf="isB2B" class="order-list__column-total">{{ 'CART.TOTAL' | translate }}<div class="iva" *ngIf="isB2B">IVA esclusa</div></th>
                                <th class="order-list__column-total">{{ 'CART.TOTAL' | translate }}<div class="iva" *ngIf="isB2B">IVA inclusa</div></th>
                            </tr>
                        </thead>
                        <tbody class="order-list__products">
                            <tr *ngFor="let item of getRighePrincipali()">
                                <td class="order-list__column-image">
                                    <!-- <div class="product-image">
                                    <a [routerLink]="root.product(item)" class="product-image__body">
                                        <img class="product-image__img" [src]="item.image" alt="">
                                    </a>
                                </div> -->
                                </td>
                                <td class="order-list__column-product">
                                    <a>{{ item.descrizioneArticolo }}</a>
                                    <ng-container *ngIf="articoliConOpzioni">
                                        <div *ngFor="let option of item.opzioni">
                                            {{getOptionLine(option,
                                            articoliConOpzioni[item.codiceArticolo])}}, Q.tà: {{item.qta}}
                                        </div>
                                    </ng-container>

                                    <div *ngIf="getComponibiliTextArrray(item.riferimentoInternoDocumento) as componibili">
                                        <div *ngFor="let comp of componibili">
                                            <div><small style="color: gray;">{{comp}}</small></div>
                                        </div>
                                    </div>

                                    <div *ngIf="getAttributiTextArray(item.riferimentoInternoDocumento) as attributi">
                                        <div *ngFor="let attr of attributi">
                                            <div><small style="color: gray;">+ {{attr}}</small></div>
                                        </div>
                                    </div>

                                    <div *ngIf="item.confezione_articolo as conf">
                                        <div><small style="color: gray;">{{conf.codice_confezione}} ({{conf.pezzi_confezione}} pz.) × {{item.qta / conf.pezzi_confezione}}</small></div>
                                    </div>

                                    <!-- <div *ngIf="item.options?.length > 0" class="order-list__options">
                                    <ul class="order-list__options-list">
                                        <li *ngFor="let option of item.options" class="order-list__options-item">
                                            <span class="order-list__options-label">{{ option.label + ': ' }}</span>
                                            <span class="order-list__options-value">{{ option.value }}</span>
                                        </li>
                                    </ul>
                                </div> -->
                                </td>
                                <td class="order-list__column-quantity" data-title="Q.tà:">{{
                                    qta_riga(item) }}</td>
                                <td *ngIf="isB2B" class="order-list__column-total">{{
                                    getTotaleRiga(item, true) | currencyFormat}}</td>
                                <td class="order-list__column-total">{{
                                    getTotaleRiga(item, false)  | currencyFormat }}</td>
                            </tr>
                        </tbody>
                        <tbody class="order-list__subtotals">
                            <tr>
                                <th class="order-list__column-label" colspan="3">{{ 'CART.SUBTOTAL' | translate }}
                                </th>
                                <td *ngIf="isB2B" class="order-list__column-total">{{ ordine.totaleImponibile |
                                    currencyFormat }}</td>
                                <td class="order-list__column-total">{{ ordine.totaleAPagare |
                                    currencyFormat }}</td>
                            </tr>
                            <!-- <tr *ngFor="let line of order.additionalLines">
                            <th class="order-list__column-label" colspan="3">{{ line.label }}</th>
                            <td class="order-list__column-total">{{ line.total|currencyFormat }}</td>
                        </tr> -->
                        </tbody>
                        <tfoot class="order-list__footer">
                            <tr>
                                <th class="order-list__column-label" colspan="3">{{ 'CART.TOTAL' | translate }}</th>
                                <td *ngIf="isB2B" class="order-list__column-total">{{ ordine.totaleImponibile |
                                    currencyFormat }}</td>
                                <td class="order-list__column-total">{{ ordine.totaleAPagare |
                                    currencyFormat }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <div class="row mt-3 no-gutters mx-n2">
                <div class="col-sm-6 col-12 px-2" *ngIf="destinazione && cliente">
                    <div class="card address-card">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{ 'CART.SHIPPING_DESTINATION' | translate }}</div>
                            <div class="address-card__name">{{ cliente.ragione_sociale}}</div>
                            <div class="address-card__row">
                                {{ destinazione.indirizzo }}<br>
                                {{ destinazione.citta }}, {{ destinazione.prov }}<br>
                                {{ destinazione.cap }}
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">{{ 'CART.PHONE' | translate }}</div>
                                <div class="address-card__row-content">{{ cliente.telefono }}</div>
                            </div>
                            <div class="address-card__row">
                                <div class="address-card__row-title">Email</div>
                                <div class="address-card__row-content">{{ cliente.email }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-12 px-2 mt-sm-0 mt-3" *ngIf="consegnaInfo">
                    <div class="card address-card">
                        <div class="address-card__body">
                            <div class="address-card__badge address-card__badge--muted">{{ 'CART.SHIPPING' | translate }}</div>

                            <div class="address-card__row">
                                <div class="address-card__row-title">{{ 'CART.SHIPPING_METHOD' | translate }}</div>
                                <div class="address-card__row-content">{{getModalitaDiSpedizione(consegnaInfo.tipo_spedizione)}}</div>
                            </div>
                            <div class="address-card__row" *ngIf="consegnaInfo.tipo_spedizione == 2 && isDataConsegnaRitiroValida(consegnaInfo.dataConsegna)">
                                <div class="address-card__row-title">{{ 'CART.DELIVERY_DATE' | translate }}</div>
                                <div class="address-card__row-content">{{ formatDate(consegnaInfo.dataConsegna) }}</div>
                            </div>
                            <div class="address-card__row" *ngIf="consegnaInfo.tipo_spedizione == 1 && isDataConsegnaRitiroValida(consegnaInfo.data_ritiro)">
                                <div class="address-card__row-title">{{ 'CART.PICKUP_DATE_TIME' | translate }}</div>
                                <div class="address-card__row-content">{{ formatDateRitiro(consegnaInfo.data_ritiro) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
 <app-restaurant-footer></app-restaurant-footer>